export default __webpack_public_path__ + "static/coworking-fdfdbe2657549da745816a0522d0b166.jpg";